<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">
              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-select-box">
                    <div class="form-group">
                      <label for="category">Категория:</label>
                      <select name="category" id="category"
                              class="form-control"
                              v-model="filter.category"
                              @change="initList"
                      >
                          <option value=""></option>
                          <option value="Notorious">Нотурар</option>
                          <option value="Residential">Турар</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_BUSINESS_COEFFICIENT_ADD')" @click="onShowBusinessCoefficientEditModal(null)">{{$t("action.add")}}</button>
              </div>

            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Категория</th>
                        <th>Қўрилиш даври(йилда)</th>
                        <th>Аванс улуши % да (Со)</th>
                        <th>Капитал қўйилманинг йиллик қайтиш нормаси % да(Уа)</th>
                        <th>Тадбиркорлик фойдасини (Ппр),%</th>
                        <th>Индекс санаси</th>
                        <th>Холати</th>
                        <th>Яратилган</th>
                        <!--<th class="text-center">{{$t("realEstate.field.action")}}</th>-->
                    </tr>
                </thead>
                <tbody v-if="!loading && results && results.data">
                    <tr v-for="result in results.data" :key="result.id">
                        <td>{{result.id}}</td>
                        <td>{{result.categoryDto.name}}</td>
                        <td>{{result.period}}</td>
                        <td>{{result.valueCo}}</td>
                        <td>{{result.valueUa}}</td>
                        <td>{{result.value}}</td>
                        <td>{{result.date}}</td>
                        <td>
                            <span v-if="result.active">Актив</span>
                            <span v-else>Актив эмас</span>
                        </td>
                        <td>{{new Date(result.createdDate ) | dateFormat('DD/MM/YYYY')}}</td>
                        <!--<td class="td-actions text-center">-->
                            <!--<button class="all-btn table-action edit-btn" data-original-title="Edit"-->
                                    <!--@click="onShowBusinessCoefficientEditModal(result)">-->
                                <!--<i class="fa fa-edit"></i>-->
                            <!--</button>-->
                        <!--</td>-->
                    </tr>
                </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <BusinessCoefficientEditModal />
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import BusinessCoefficientEditModal from '@/views/config/real-estate/BusinessCoefficientEditModal'
    export default {
        name: "BusinessCoefficientList",
        components: {
            'b-pagination': bPagination,
            BusinessCoefficientEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('business-coefficient/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onShowBusinessCoefficientEditModal(data) {
                this.$eventBus.$emit('showBusinessCoefficientEditModal', data);
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('businessCoefficientFieldChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>